"use client";

import { useEffect } from "react";
import { type SignupPrefill, writeSignupPrefill } from "../../lib/signup-prefill";

export const useSignupPrefill = (prefill: SignupPrefill | null) => {
	const isEnabled = prefill !== null;
	const email = prefill?.email;
	const connectPermitPublicIdentifier = prefill?.connectPermitPublicIdentifier;

	useEffect(() => {
		if (isEnabled) {
			writeSignupPrefill({ email, connectPermitPublicIdentifier });
		}
	}, [isEnabled, email, connectPermitPublicIdentifier]);
};
